import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { Button } from '../ui/Button';
const CREDENTIALS = ['LL.B', 'B.A', 'LLM', 'Commercial Law Accredited Specialist'];
export function TeamAuthority() {
  return <section className="bg-background px-5 py-10 md:px-6 md:py-14" data-id="element-375" data-mp="3vhnkl59q1wqm">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-376" data-mp="3rjhhc783dzag">
        <figure className="border-y border-border py-6" data-id="element-377" data-mp="33tddbyqzrxix">
          <div className="mb-5 flex items-center gap-1 text-peach-dark" data-id="element-378" data-mp="2ytqzpo794f9l">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4" fill="currentColor" data-id="element-379" data-mp="3cl5pcdvnzepm" data-mpi={i} />)}
          </div>
          <blockquote className="font-serif text-3xl leading-snug text-ink md:text-4xl" data-id="element-380" data-mp="37txfjgqf9rbx">
            “Thorough, responsive and knowledgeable.”
          </blockquote>
          <figcaption className="mt-5 text-sm font-semibold uppercase tracking-[0.16em] text-muted-ink" data-id="element-381" data-mp="2g2zk44wo7smr">
            Client feedback
          </figcaption>
        </figure>

        <div data-id="element-382" data-mp="2795cgh3ugu54">
          <p className="eyebrow text-brand-blue" data-id="element-383" data-mp="277kpbcjv0dha">a real person, not a portal</p>
          <h2 className="mt-2 font-serif text-3xl leading-tight text-ink md:text-[2.6rem]" data-id="element-384" data-mp="2c6p1mc22yrbu">
            Legal advice from people you can identify.
          </h2>
          <p className="mt-3 text-xl font-semibold text-ink" data-id="element-385" data-mp="2lyl1nsnq8rip">
            Linda Ashley, Principal Solicitor.
          </p>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-muted-ink" data-id="element-386" data-mp="1oc42ehvfo3ub">
            Linda's associated firm profile describes experience across
            property, commercial transactions, trusts, SMSFs, contracts and
            related disputes. You deal with a solicitor who knows your matter,
            not a rotating queue.
          </p>

          <div className="mt-7 flex flex-wrap gap-2" data-id="element-387" data-mp="39o5r8uedyn0y">
            {CREDENTIALS.map(credential => <span key={credential} className="rounded-full border border-border bg-surface px-3.5 py-1.5 text-sm font-medium text-ink" data-id="element-388" data-mp="3emh31ao8r7lt">
                {credential}
              </span>)}
          </div>

          <div className="mt-8" data-id="element-389" data-mp="19o0ljpt9hlit">
            <Link to="/team" data-id="element-390" data-mp="1nlxiinbmnty0">
              <Button variant="primary" data-id="element-391" data-mp="1nk4elfsefntp">Meet the legal team</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}